// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function PageHeading(props) {
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx("h1", {
    children: props.children,
    className: TailwindMerge.twMerge([
      "text-zinc-800 text-3xl font-medium",
      className
    ]),
    id: props.id
  });
}

let make = PageHeading;

exports.make = make;
/* tailwind-merge Not a pure module */
